module.exports = __webpack_public_path__ + "img/09-cross-error.4eaa3bef.svg";